var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kbm-links"},_vm._l((_vm.links),function(value,key){return _c('v-layout',{key:key,attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"maxWidth":"600px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('a',_vm._g({},on),[_vm._v(_vm._s(value.linkText))])]}}],null,true)},[_vm._v(" "),_c('v-card',{staticClass:"kbm-card"},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(value.bodyText)}})],1)],1)],1)}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32a4270a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/KbmLinks.vue
// module id = YWDj
// module chunks = 0